export class PerformanceForShatter {
    constructor() {
        console.log('performance');
    }
    init() {
        console.log('performance init');
    }
}